module.exports = __webpack_public_path__ + "img/banner-11-1@2x.8c9a53c3.jpg";